import React from 'react';

const Logo = ({ variant = 'light' }) => {
  const isDark = variant === 'dark';
  // Logo PNG is pure black on transparent. On dark backgrounds we invert it to white.
  return (
    <div className="flex items-center select-none">
      <img
        src="/assets/fortune-logo.png"
        alt="Fortune Auto Design"
        width={272}
        height={76}
        style={{
          height: '76px',
          width: 'auto',
          objectFit: 'contain',
          filter: isDark ? 'none' : 'invert(1) brightness(2)',
        }}
        draggable={false}
      />
    </div>
  );
};

export default Logo;
